import { Controller } from '@hotwired/stimulus'
import Swiper from 'swiper'

export default class extends Controller {
  static targets = [ 'prevButton', 'nextButton' ]

  connect() {
    new Swiper(this.element, {
      centeredSlides: true,
      slidesPerView: 1,
      loop: true,
      navigation: {
        prevEl: this.prevButtonTarget,
        nextEl: this.nextButtonTarget,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }
    })
  }
}
